import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderStatusPipe } from '../pipes/order-status.pipe';
import { PaymentLocationLabelPipe } from '../pipes/payment-location-label.pipe';
import { ParticularOrderStatusPipe } from '../pipes/particular-order-status.pipe';

@NgModule({
  declarations: [
    OrderStatusPipe,
    PaymentLocationLabelPipe,
    ParticularOrderStatusPipe,
  ],
  imports: [CommonModule],
  exports: [
    OrderStatusPipe,
    PaymentLocationLabelPipe,
    ParticularOrderStatusPipe,
  ],
})
export class SharedModule {}
